module.exports = __webpack_public_path__ + "fonts/youtube-168_svgrepo.com.svg";